import { ComposeViewState } from 'owa-mail-compose-store';
import { action } from 'satcheljs/lib/legacy';

export default action('toggleRibbon')(function toggleRibbon(viewState: ComposeViewState) {
    viewState.isRibbonShown = !viewState.isRibbonShown;
});
